export enum ProductId {
  Group = 0,
  Payroll = 1,
  Sign = 2,
}

export const productInfo = {
  [ProductId.Payroll]: {
    name: 'payroll',
  },
  [ProductId.Sign]: {
    name: 'sign',
  },
};
